import axios from 'axios';

export type GetOfficesDTO = {
  oid: string;
  mls: string;
  location: string;
  address: string;
  board: string;
}[];

const getOffices = async () => {
  const {
    data: {
      org: { boards },
    },
  } = await axios.get<{
    org: {
      boards: GetOfficesDTO;
    };
  }>(`/org/offices`);

  return boards;
};

export default getOffices;
